export default "__VITE_ASSET__BzFIGPyI__"